import React from 'react';
import PropTypes from 'prop-types';

import { Blurred, Grid, Link } from '../../common';
import {
  OFFLINE_SEPA_VALUE,
  INSTALLMENT_VALUE,
  SEPA_DIRECT_DEBIT_VALUE,
  SEPA_IMAGE,
} from '../../../constants/payment';
import * as routes from '../../../constants/routes';

import { filterPaymentMethods } from '../../../utils/payment';

const Payment = ({
  balance,
  paymentMethods: clearPaymentMethods,
  paymentHide,
  blur,
  styles,
}) => {
  let paymentMethods;
  if (paymentHide) {
    paymentMethods = clearPaymentMethods.slice(0, 1);
  } else {
    const firstSepaValueFromOrder = [
      OFFLINE_SEPA_VALUE,
      INSTALLMENT_VALUE,
      SEPA_DIRECT_DEBIT_VALUE,
    ].reduce((acc, sepaValue) => {
      if (!acc.found) {
        const method = clearPaymentMethods.find(
          ({ value }) => value === sepaValue
        );
        if (method) {
          acc = method;
          acc.found = true;
        }
      }
      return acc;
    }, {});
    paymentMethods = clearPaymentMethods.reduce((acc, method) => {
      if (method.image !== SEPA_IMAGE) {
        acc.push(method);
      } else if (method.value === firstSepaValueFromOrder.value) {
        const { found, ...sepaMethod } = firstSepaValueFromOrder;
        acc.push(sepaMethod);
      }
      return acc;
    }, []);
    paymentMethods = filterPaymentMethods(paymentMethods, { balance });
  }

  return (
    <div className={styles['payment__wrapper']}>
      <Grid
        container
        justify="center"
        spacing={1}
        className={styles['payment__payment']}
      >
        {paymentMethods.length > 0
          ? paymentMethods.map(({ label, image, value, id }, key) => (
              <Grid item key={key}>
                <Blurred blur={blur}>
                  <Link
                    id={`page.home.component.payment-list.${id}`}
                    to={`${routes.PAYMENTS}?method=${value}`}
                  >
                    <img
                      className={styles['payment__payment-icon']}
                      src={image}
                      alt={`${label}-logo`}
                    />
                  </Link>
                </Blurred>
              </Grid>
            ))
          : null}
      </Grid>
    </div>
  );
};

Payment.propTypes = {
  paymentMethods: PropTypes.array,
  paymentHide: PropTypes.bool,
  styles: PropTypes.object,
};

export default Payment;
